import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArrowDropUpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"arrow_drop_up"}/>
}
